import { clearCredentials } from './clearCredentials'
import {
  accessTokenPresent,
  getCurrentAccessLevel,
  getCurrentUserId,
} from './credentials'
import { setCredentials } from './setCredentials'
import {
  ICredentials,
  SessionActionTypes,
  UPDATE_SESSION,
  SET_ONBOARDING_REQUIRED,
  SET_SKIPPED_ONBOARDING,
  AccessLevel,
} from './types'

export const updateCredentials = (creds: ICredentials): void => {
  console.log('update credentials', creds)
  setCredentials(creds)
}

export const updateSession = (
  newSession: ICredentials,
  options: {
    onboardingRequired?: boolean
    skippedOnboarding?: boolean
  } = {}
): SessionActionTypes => {
  console.log('update session', newSession, options)
  updateCredentials(newSession)
  return {
    payload: {
      accessLevel: getCurrentAccessLevel(),
      isAuthenticated: accessTokenPresent(),
      sessionInvalidated: false,
      userId: getCurrentUserId(),
      // Use provided values or defaults
      onboardingRequired:
        options.onboardingRequired !== undefined
          ? options.onboardingRequired
          : true,
      skippedOnboarding:
        options.skippedOnboarding !== undefined
          ? options.skippedOnboarding
          : false,
    },
    type: UPDATE_SESSION,
  }
}

export const clearSession = (
  flags: { invalidSession: boolean } | undefined
): SessionActionTypes => {
  clearCredentials()
  return {
    payload: {
      accessLevel: AccessLevel.User,
      isAuthenticated: accessTokenPresent(),
      sessionInvalidated: (flags && flags.invalidSession) || false,
      userId: getCurrentUserId(),
      onboardingRequired: true,
      skippedOnboarding: false,
    },
    type: UPDATE_SESSION,
  }
}

export const setOnboardingRequired = (
  required: boolean
): SessionActionTypes => {
  return {
    type: SET_ONBOARDING_REQUIRED,
    payload: { onboardingRequired: required },
  }
}

export const setSkippedOnboarding = (skipped: boolean): SessionActionTypes => {
  return {
    type: SET_SKIPPED_ONBOARDING,
    payload: { skippedOnboarding: skipped },
  }
}
